import cTooltip from '~/modules/cTooltip/tooltipManager';

export default {
  mounted() {
    let customTooltip = new cTooltip();
    customTooltip.init();
  }
};